import { AwsS3Audit } from "@p0security/integrations-aws-s3-audit-frontend";
import { AwsSqs } from "@p0security/integrations-aws-sqs-frontend";
import { Datadog } from "@p0security/integrations-datadog-frontend";
import { JiraTracker } from "@p0security/integrations-jira-tracker-frontend";
import { Splunk } from "@p0security/integrations-splunk-events-frontend";
import { useFlags } from "launchdarkly-react-client-sdk";
import { Outlet, Route } from "react-router";

import { Page } from "../App/Page";
import { Email } from "./Email/Email";
import { GrafanaIrm } from "./GrafanaIrm/GrafanaIrm";
import { IncidentIo } from "./IncidentIo/IncidentIo";
import { IntegrationsList } from "./Integrations";
import { IntegrationsContextProvider } from "./IntegrationsContext.tsx";
import { Jira } from "./Jira/Jira";
import { Pagerduty } from "./Pagerduty/Pagerduty";
import { Slack } from "./Slack/Slack";
import { Teams } from "./Teams/Teams";
import { installSiblings } from "./installers.tsx";
import { resourceIntegrationRoutes } from "./installers.tsx";

export const IntegrationRoutes = () => {
  const flags = useFlags();

  return (
    <Route
      path="integrations"
      element={
        <IntegrationsContextProvider>
          <Outlet />
        </IntegrationsContextProvider>
      }
    >
      <Route
        index
        element={
          <Page title="Integrations">
            <IntegrationsList />
          </Page>
        }
      />
      <Route
        path="pagerduty"
        element={
          <Page title="Pagerduty">
            <Pagerduty />
          </Page>
        }
      />
      <Route
        path="incidentio"
        element={
          <Page title="Incident.io">
            <IncidentIo />
          </Page>
        }
      />
      <Route
        path="grafana-irm"
        element={
          <Page title="Grafana IRM">
            <GrafanaIrm />
          </Page>
        }
      />
      {/* Note that we can't guard this behind a flag b/c it has to be accessible prior to login */}
      <Route
        path="jira"
        element={
          <Page title="Jira (Legacy)">
            <Jira />
          </Page>
        }
      />
      {!flags?.showLegacyJiraTracker && (
        <Route
          path="jira-tracker"
          element={
            <Page title="Jira">
              <JiraTracker siblings={installSiblings} />
            </Page>
          }
        >
          <Route path=":component" element={<Outlet />}>
            <Route path=":id" element={null} />
          </Route>
        </Route>
      )}
      <Route
        path="slack"
        element={
          <Page title="Slack">
            <Slack />
          </Page>
        }
      />
      <Route
        path="ms-teams"
        element={
          <Page title="Microsoft Teams">
            <Teams />
          </Page>
        }
      />
      <Route
        path="email"
        element={
          <Page title="Email">
            <Email />
          </Page>
        }
      />
      <Route
        path="aws-sqs"
        element={
          <Page title="Amazon SQS">
            <AwsSqs siblings={installSiblings} />
          </Page>
        }
      >
        <Route path=":component" element={<Outlet />}>
          <Route path=":id" element={null} />
        </Route>
      </Route>
      <Route
        path="aws-s3-audit"
        element={
          <Page title="Amazon S3 (audit logs)">
            <AwsS3Audit siblings={installSiblings} />
          </Page>
        }
      >
        <Route path=":component" element={<Outlet />}>
          <Route path=":id" element={null} />
        </Route>
      </Route>
      <Route
        path="datadog"
        element={
          <Page title="Datadog">
            <Datadog siblings={installSiblings} />
          </Page>
        }
      >
        <Route path=":component" element={<Outlet />}>
          <Route path=":id" element={null} />
        </Route>
      </Route>

      <Route
        path="splunk"
        element={
          <Page title="Splunk">
            <Splunk siblings={installSiblings} />
          </Page>
        }
      >
        <Route path=":component" element={<Outlet />}>
          <Route path=":id" element={null} />
        </Route>
      </Route>

      {...resourceIntegrationRoutes(flags)}
    </Route>
  );
};
